module.exports = __webpack_public_path__ + "static/media/moon-cloud.e28acb03.svg";